import { useState, useEffect } from 'react';
import { fetchStudioOverallOverviewVisualisData } from '@gp/pages/StudioDashboard/StudioOverall/services/studioOverall';
import DataTypeUtils from '@gp/utils/DataTypeUtils';

export default function useFinanceVisualis({
  setFinancialOverviewDataTime,
}: {
  setFinancialOverviewDataTime: React.Dispatch<React.SetStateAction<string>>,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const [revenueBarChartData, setRevenueBarChartData] = useState<
    IEChartDataEntity[]
  >([]);
  const [profitBarChartData, setProfitBarChartData] = useState<
    IEChartDataEntity[]
  >([]);

  const handleResData = (data: any[]): IEChartDataEntity[] => {
    if (!DataTypeUtils.isArray(data)) return [];
    return data
      .map((item) => {
        return {
          ...item,
          actual: item?.revenue,
        };
      })
      /* .sort((a, b) => b.actual - a.actual) */;
  };

  const init = async () => {
    try {
      setIsLoading(true);
      const res: any = await fetchStudioOverallOverviewVisualisData();
      const revenueData = handleResData(res?.revenue);
      const profitData = handleResData(res?.profit);
      setRevenueBarChartData(revenueData);
      setProfitBarChartData(profitData);
      setFinancialOverviewDataTime?.(res?.dataTime || '');
    } catch (exception) {
      console.warn(exception);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  return {
    isLoading,
    revenueBarChartData,
    profitBarChartData,
  };
}
